import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Images, SavePage } from 'utils';
import { inputsStyle } from './styles';

export const SearchInput = ({ name, placeholder, className, saveParams={}, defaultStyles }) => {
  const classes = inputsStyle();
  const [value, setValue] = useState('');
  const ref = useRef();
  const history = useHistory();
  const info = history?.location?.state;

  useEffect(() => {
    if (info?.[name]) {
      setValue(info?.[name]);
    }else{
      setValue('');
    }
  }, [info?.[name]]);
  const handleSend = () => {
    const params = {
      ...saveParams
    };
    value ? params[name] = value : delete params[name];
    SavePage(history, info, params);
  };

  const handleSetValue = (e) => {
    if(e.target.value === ''){
      const params = {
        ...info,
      };
      delete params[name];
      setValue('')

      if(info?.[name]){
        SavePage(history, info, params);
      }
    }else{
      setValue(e.target.value)
    }
  }

  return (
    <div className={className ? className : ''}>
      <div style={defaultStyles ? {} : value ? { borderColor: '#438AFE' } : {}} className={`search-input-main-wrapper ${classes.searchInputWrapper}`}>
        <input
          ref={ref}
          type='search'
          onChange={handleSetValue}
          placeholder={placeholder}
          value={value}
        />
        <button onClick={handleSend} style={value ? { borderColor: '#438AFE' } : {}}>
          <img src={Images.searchIcon} alt={'icon'} />
        </button>
      </div>
    </div>
  );
};